const NULLISH_NAME_PARTS = new Set(['null', 'undefined']);

const normalizeClientName = (name: string | null | undefined): string | null => {
  const trimmedName = name?.trim();

  if (!trimmedName) {
    return null;
  }

  const nameParts = trimmedName.split(/\s+/);
  const isNullishName = nameParts.every((part) => NULLISH_NAME_PARTS.has(part.toLowerCase()));

  return isNullishName ? null : trimmedName;
};

export const getDeliveryClientDisplayName = (
  detailClientName: string | null | undefined,
  fallbackClientName?: string | null
): string => {
  return normalizeClientName(detailClientName) ?? normalizeClientName(fallbackClientName) ?? '-';
};

export const getDeliveryClientInitials = (clientName: string): string => {
  return clientName === '-' ? '-' : clientName.substring(0, 2).toUpperCase();
};
